const insertIf = <T extends any>(condition: any, ...elements: T[]) => {
  return condition ? elements : [];
};

export default insertIf;
